<template>
  <div class="page-swiper">
    <div class="swiper-search">
      <span class="search-label">轮播图名称</span>
      <el-input
        class="search-input"
        size="small"
        v-model="pictureName"
        placeholder="请输入内容"
      ></el-input>
      <el-button
        class="search-but1"
        size="small"
        type="primary"
        @click="handleSearch"
      >
        搜索
      </el-button>
      <el-button class="search-but1" size="small" @click="handleReset">
        重置
      </el-button>
    </div>
    <div class="swiper-add">
      <el-button size="small" type="primary" @click="handleAdd">
        新建
      </el-button>
    </div>
    <div class="swiper-table">
      <el-table
        :data="swiperList"
        style="width: 100%"
        :border="true"
        v-loading="loading"
        row-key="id"
      >
        <el-table-column
          v-for="item in column"
          :key="item.prop"
          :prop="item.prop"
          :label="item.label"
          align="center"
          :min-width="item.width || '100'"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <template v-if="item.prop === 'pictureUrl' && scope.row.pictureUrl">
              <img
                class="table-img"
                :src="scope.row.pictureUrl"
                alt="轮播图"
                @click="lookBigImg(scope.row)"
              />
            </template>
            <template v-else-if="item.prop !== 'pictureUrl'">
              {{ tableTranslation(item.prop, scope.row) }}
            </template>
          </template>
        </el-table-column>
        <el-table-column
          key="option"
          prop="option"
          label="操作"
          align="center"
          min-width="100"
          fixed="right"
        >
          <template slot-scope="scope">
            <el-button type="text" @click="handleStatus(scope.row)">
              {{ scope.row.state === 2 ? '停用' : '启用' }}
            </el-button>
            <el-button type="text" @click="handleEditor(scope.row)">
              编辑
            </el-button>
            <el-button
              v-if="scope.row.state === 1"
              type="text"
              @click="handleDel(scope.row)"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="swiper-pagination">
      <el-pagination
        @size-change="handleLimitChange"
        @current-change="handlePageChange"
        :current-page="page"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
    <WriteDialog
      v-if="writeDialogFlag"
      :dialogTitle="writeDialogTitle"
      :handleClose="handleCloseWriteDialog"
      :defaultData="writeDialogData"
    />
    <PublicShowImg ref="showImgRef" />
  </div>
</template>
<script>
import { column } from './assets'
import WriteDialog from './writeDialog.vue'
import * as API from '../../api/swipers/index'
import PublicShowImg from './openImg.vue'
export default {
  name: 'SwiperManage',
  components: { WriteDialog, PublicShowImg },
  data() {
    return {
      column,
      pictureName: '',
      swiperList: [],
      total: 0,
      page: 1,
      limit: 10,
      writeDialogFlag: false,
      writeDialogTitle: '',
      writeDialogData: {},
      loading: false
    }
  },
  created() {
    this.getSwiperList()
  },
  methods: {
    async getSwiperList() {
      this.loading = true
      try {
        const { limit, page, pictureName } = this
        const params = {
          limit,
          page,
          pictureName
        }
        const res = await API.getSwiperList(params)
        const {
          code,
          data: { records = [], total }
        } = res
        if (code === 0) {
          this.swiperList = records
          this.total = Number(total)
        }
      } catch (error) {
      } finally {
        this.loading = false
      }
    },
    // 搜索
    handleSearch() {
      this.page = 1
      this.getSwiperList()
    },
    // 重置
    handleReset() {
      this.page = 1
      this.limit = 10
      this.pictureName = ''
      this.getSwiperList()
    },
    // 表格单元格转换
    tableTranslation(key, row) {
      switch (key) {
        case 'state':
          switch (row[key]) {
            case 1:
              return '已停用'
            case 2:
              return '已启用'
            default:
              return ''
          }
        default:
          return row[key]
      }
    },
    // 单元格点击查看封面大图
    lookBigImg(row) {
      const { pictureUrl, pictureName } = row
      this.$refs.showImgRef.show(pictureUrl, pictureName)
    },
    // 编辑轮播图
    handleEditor(row) {
      this.writeDialogTitle = '编辑轮播图'
      this.writeDialogData = row
      this.writeDialogFlag = true
    },
    // 表格操作项点击删除
    handleDel(row) {
      const { id, pictureName } = row
      this.$confirm(`确认要删除${pictureName}吗？`, {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(async () => {
          const res = await API.delSwiper(id)
          const { code } = res
          if (code === 0) {
            this.getSwiperList()
          }
        })
        .catch(() => {})
    },
    // 表格操作项点击停用、启用
    async handleStatus(row) {
      const { id, state, pictureName } = row
      this.$confirm(
        `确认要${state === 2 ? '停用' : '启用'}${pictureName}吗？`,
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        }
      )
        .then(async () => {
          const res = await API.stateSwiper(id)
          const { code } = res
          if (code === 0) {
            this.$message.success(`${state === 2 ? '停用' : '启用'}成功`)
            this.getSwiperList()
          }
        })
        .catch(() => {})
    },
    // 新建、编辑轮播图弹框关闭
    handleCloseWriteDialog(bool) {
      this.writeDialogFlag = false
      switch (bool) {
        case 'reset':
          this.handleReset()
          break
        case 'update':
          this.getSwiperList()
          break
        default:
          break
      }
    },
    // 新建轮播图
    handleAdd() {
      this.writeDialogTitle = '新建轮播图'
      this.writeDialogData = {}
      this.writeDialogFlag = true
    },
    // 换每页条数
    handleLimitChange(limit) {
      this.limit = limit
      this.page = 1
      this.getSwiperList()
    },
    // 换页
    handlePageChange(page) {
      this.page = page
      this.getSwiperList()
    }
  }
}
</script>
<style scoped lang='scss'>
.page-swiper {
  background: #fff;
  padding: 20px;
  .swiper-search {
    margin-bottom: 20px;
    .search-label {
      margin-right: 10px;
    }
    .search-input {
      width: 230px;
      margin-right: 100px;
    }
    .search-but1 {
      margin-right: 10px;
    }
    .search-but2 {
      margin-right: 10px;
    }
  }
  .swiper-add {
    margin-bottom: 20px;
  }
  .swiper-table {
    margin-bottom: 20px;
    .table-img {
      width: 100px;
      height: 20px;
      cursor: pointer;
    }
  }
}
</style>